import { useEffect, useState } from "react";
import { Api } from "../api";
import { TeamType } from "../api/types/Teams";

export function makeTeamTypesMap(teamTypes: Array<TeamType>) {
  const names = new Map<string, TeamType>();
  for (const teamType of teamTypes) {
    names.set(teamType.name, teamType);
  }
  return names;
}

export function useTeamTypesArray(setLoaded?: (loaded: boolean) => void) {
  let isCanceled = false;
  const [teamTypes, setTeamTypes] = useState<Array<TeamType>>([]);

  useEffect(() => {
    Api.teams
      .getTeamTypes()
      .then(teamTypes => {
        if (!isCanceled) {
          setTeamTypes(teamTypes.data);
          if (setLoaded) setLoaded(true);
        }
      })
      .catch(error => {
        console.error("Team Types Array:", error);
      });
    return () => {
      isCanceled = true;
    };
  }, []);
  return teamTypes;
}

export function useTeamTypes() {
  let isCanceled = false;
  const [teamTypes, setTeamTypes] = useState<Map<string, TeamType>>(new Map());
  const getTeamTypes = async () => {
    let names = new Map<string, TeamType>();
    try {
      const teamTypes = await Api.teams.getTeamTypes();
      names = makeTeamTypesMap(teamTypes.data);
      if (!isCanceled) {
        setTeamTypes(names);
      }
    } catch (error) {
      console.error("Team Types:", error);
    }
    return names;
  };

  useEffect(() => {
    getTeamTypes();
    return () => {
      isCanceled = true;
    };
  }, []);
  return teamTypes;
}
